// Pause and play the video, and change the button class
window.videobg = function(id) {
    var video = document.getElementById("video-"+id);
    var btn = document.getElementById("video-btn-"+id); 
    if (video.paused) {
        video.play();  
        btn.classList.remove('play-btn');
        btn.classList.add('pause-btn');
    } else {
        video.pause();
        btn.classList.remove('pause-btn');
        btn.classList.add('play-btn');
    }
}